import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

const routes: Routes = [
  {
    path: "",
    loadChildren: () =>
      import("../../public/public.module").then((m) => m.PublicModule),
  },
  {
    path: "orders",
    loadChildren: () =>
      import("../../orders/order.module").then((m) => m.OrderModule),
  },
  {
    path: "why-ilc",
    loadChildren: () =>
      import("../../why-ilc/why-ilc.module").then((m) => m.WhyIlcModule),
  },
  {
    path: "products",
    loadChildren: () =>
      import("../../products/products.module").then((m) => m.ProductsModule),
  },
  {
    path: "publications",
    loadChildren: () =>
      import("../../publications/publications.module").then(
        (m) => m.PublicationsModule
      ),
  },
  {
    path: "careers",
    loadChildren: () =>
      import("../../careers/careers.module").then((m) => m.CareersModule),
  },
  {
    path: "contact",
    loadChildren: () =>
      import("../../contact/contact.module").then((m) => m.ContactModule),
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      initialNavigation: "enabledBlocking",
      scrollPositionRestoration: "top"
    }),
  ],
  exports: [RouterModule],
  declarations: [],
})
export class AppRoutingModule {}
